import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=f7e74588&scoped=true"
import script from "./Layout2.vue?vue&type=script&lang=js"
export * from "./Layout2.vue?vue&type=script&lang=js"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=f7e74588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e74588",
  null
  
)

export default component.exports